import { ReactNode } from "react";
import { Skeleton } from "@/components/ui/skeleton";
import { EmptyState } from "./EmptyState";
import { ErrorCard } from "./ErrorCard";

interface ListShellProps {
  isLoading: boolean;
  error: unknown;
  isEmpty: boolean;
  onRetry?: () => void;
  emptyTitle?: string;
  emptyDescription?: string;
  children: ReactNode;
}

const TableSkeleton = () => (
  <div className="space-y-2 p-4">
    {Array.from({ length: 6 }).map((_, i) => (
      <Skeleton key={i} className="h-10 w-full" />
    ))}
  </div>
);

export const ListShell = ({
  isLoading,
  error,
  isEmpty,
  onRetry,
  emptyTitle = "No records found",
  emptyDescription,
  children,
}: ListShellProps) => (
  <div className="bg-card rounded-card border border-border overflow-hidden">
    {isLoading ? (
      <TableSkeleton />
    ) : error ? (
      <div className="p-4">
        <ErrorCard
          message={(error as Error).message || "Failed to load"}
          onRetry={onRetry}
        />
      </div>
    ) : isEmpty ? (
      <EmptyState title={emptyTitle} description={emptyDescription} />
    ) : (
      children
    )}
  </div>
);

export default ListShell;
